import { render, staticRenderFns } from "./TrainingInProgress.vue?vue&type=template&id=2e6b21dc"
import script from "./TrainingInProgress.vue?vue&type=script&lang=js"
export * from "./TrainingInProgress.vue?vue&type=script&lang=js"
import style0 from "./TrainingInProgress.vue?vue&type=style&index=0&id=2e6b21dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports